import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { withAbsoluteHomeRows as t } from "./rejoinHomeRows.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
import { useIsAuthenticated as i } from "@maat/store-auth";
//#region src/properties/useGuestHomePersonalQuery.ts
var a = () => {
	let a = i();
	return n({
		queryKey: e.guestHomePersonal(),
		queryFn: r.getGuestHomePersonal,
		enabled: a,
		select: t,
		staleTime: 6e4,
		retry: 1,
		retryDelay: 1e3,
		refetchOnWindowFocus: !1
	});
};
//#endregion
export { a as useGuestHomePersonalQuery };
